export { TableFooterPagination } from './TableFooterPagination';
export type { TableFooterPaginationProps } from './TableFooterPagination';
